import {
  get,
  post,
  download,
  downloadFile,
  upload,
  BASEURL,
  ADMIN_URL,
  AUTH_URL,
  COMMON_DL_URL,
  COMMON_DICT_URL,
  COMMON_QRCODE_URL,
  COMMON_FILE_URL
} from "./https.js";
import { D_URL, postByJson, URL } from "./https";

// 文件上传url
const UPLOAD_FILE_URL = COMMON_FILE_URL + "upload";
//背景图片上传url
const UPLOAD_BACKGROUND_URL = COMMON_FILE_URL + "upload";
export default {
  UPLOAD_FILE_URL,
  UPLOAD_BACKGROUND_URL,
  // LOGIN 的处理
  doLogin(param) {
    return post(AUTH_URL + "login", param);
  },
  // 学生LOGIN 的处理
  doStudentLogin(param) {
    return post(AUTH_URL + "studentLogin", param);
  },
  // 查询当前用户信息
  getUserRole(param) {
    return post(AUTH_URL + "getUserRole", param);
  },
  // LOGOUT 的处理
  doLogout() {
    return post(AUTH_URL + "logout");
  },
  // 生成二维码
  addQrCode() {
    return get(COMMON_QRCODE_URL + "addQrCode");
  },
  // 激活页面 -- 初始化处理
  doActiveInit() {
    return get(ADMIN_URL + "active/init");
  },
  // 激活页面 -- 激活操作
  doActive(param) {
    return post(ADMIN_URL + "active/doActive", param);
  },
  // 获取激活信息
  getActiveMsg(param) {
    return post(ADMIN_URL + "active/getActiveMsg", param);
  },

  // 下载学生导入模板
  dlImportStudentTemplate(param) {
    return download(COMMON_DL_URL + "res", param);
  },

  // 更新老师，学生头像
  updateUserPhoto(param) {
    return post(AUTH_URL + "updatePhoto", param);
  },

  // 下载静态文件（后台静态资源、包括临时生成文件）
  downloadFile(url, fileName) {
    downloadFile(url, fileName);
  },

  // 查询素材类型
  listResourceType() {
    return get(COMMON_DICT_URL + "list/resource/type");
  },

  // 查询素材类型
  listResourceTypeB() {
    return get(COMMON_DICT_URL + "list/resource/typeB");
  },
  // 查询试题类型
  listExerciseType(param) {
    return get(COMMON_DICT_URL + "list/exercise/type", param);
  },
  // 查询分组任务的流程
  listGtFlow(param) {
    return get(COMMON_DICT_URL + "list/gt/flow", param);
  },
  // 查询分组任务流程的角色数量
  listGtFlowRoleNum() {
    return get(COMMON_DICT_URL + "/list/gt/flow/role/num");
  },
  getLicenseInfo() {
    return get(BASEURL + "com/license");
  },
  activeProduct(param) {
    return post(BASEURL + "com/active", param);
  },
  noticeSave(param) {
    return postByJson(BASEURL + "common/notices/save", param);
  },
  noticesPaging(param) {
    return get(BASEURL + "common/notices/paging", param);
  },
  isOpenNotice() {
    return get(BASEURL + "common/notices/openStatus");
  },
  // 查询h5系列
  listGameType() {
    return get(COMMON_DICT_URL + "/list/game/type");
  },

  //获取当前城市
  // getCurrentCity() {return get('http://pv.sohu.com/cityjson?ie=utf-8')}

  listCourses() {
    return get(URL + "v3xbox/" + "common/course" + "/getUserCourseList");
  },

  listResCourse() {
    return get(URL + "v3xbox/" + "common/course" + "/getResCourseList");
  },

  getCourseTypeId(param) {
    return get(
      URL + "v3xbox/" + "common/course" + "/getCourseTypeByCourseId",
      param
    );
  },

  getUserStudyCourseList() {
    return get(URL + "v3xbox/" + "common/course" + "/getUserStudyCourseList");
  },

  getTextBookList(param) {
    return get(URL + "v3xbox/" + "common/course" + "/list", param);
  },

  //查询课程类型
  courseType(param) {
    return get(D_URL + "/d0003/courseType", param);
  },
  courseTypeByCourseKey(param) {
    return get(D_URL + "/d0003/courseTypeByCourseKey", param);
  },
  courseTypeByKhzyFsId(param) {
    return get(D_URL + "/d0003/courseTypeByKhzyFsId", param);
  },
  courseTypeByCourseId(param) {
    return get(D_URL + "/d0003/courseTypeByCourseId", param);
  },

  getException(param) {
    return get(URL + "v3xbox" + "/common/exception/getExceptionList", param);
  },

  getAllMajor() {
    return get(COMMON_DICT_URL + "/majors");
  },
  getAllTextBook() {
    return get(COMMON_DICT_URL + "/textBooks");
  },
  uploadAvatarPhoto(data) {
    return post(AUTH_URL + "/updatePhoto", data);
  },

  // 生成分享二维码(V4.3.2)
  createShareQrCode(courseId) {
    return get(COMMON_QRCODE_URL + "createShareQrCode?courseId=" + courseId);
  },
  // 上传文件
  commonUpload(param) {
    return upload(UPLOAD_FILE_URL, param);
  },
  // AI助手
  getAIMessage(param) {
    return get(BASEURL + "chat", param);
  }
};



// WEBPACK FOOTER //
// ./src/components/tools/request/common.js